"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.undeterminedStricterOfClock = undeterminedStricterOfClock;
/**
 * Helper to provide copy when a generator status is missing, for specifically
 * those states where the "effective" generator status is the stricter of (state, federal)
 */
function undeterminedStricterOfClock(ctx, stateName) {
    const missingAxes = [];
    if (ctx.generatorStatus === null) {
        missingAxes.push("generatorStatus");
    }
    if (ctx.stateGeneratorStatus === null) {
        missingAxes.push("stateGeneratorStatus");
    }
    const stricterOf = `Storage deadlines in ${stateName} depend on the generator status, which is the stricter of the federal status and ` +
        `${stateName}'s own determination`;
    if (ctx.generatorStatus !== null) {
        return {
            kind: "UNDETERMINED",
            missingAxes,
            reason: `${stricterOf}. The federal status is known, but the ${stateName} status is not. It is ` +
                "calculated from the waste the facility generates.",
        };
    }
    if (ctx.stateGeneratorStatus !== null) {
        return {
            kind: "UNDETERMINED",
            missingAxes,
            reason: `${stricterOf}. The ${stateName} status is known, but the federal status is not. It ` +
                "comes from the facility's EPA registration or its shipment history.",
        };
    }
    return {
        kind: "UNDETERMINED",
        missingAxes,
        reason: `${stricterOf}, and neither is known. The federal status comes from the facility's ` +
            `EPA registration or its shipment history; the ${stateName} status is calculated from the ` +
            "waste the facility generates.",
    };
}
//# sourceMappingURL=undeterminedStricterOfClock.js.map